// SPDX-License-Identifier: AGPL-3.0-only

import { createApp, type App as VueApplication } from "vue";
import App from "./App.vue";
import { router } from "./router/index.js";
import { pinia } from "./stores/pinia.js";
import "./styles/main.css";

const application: VueApplication = createApp(App);
application.use(pinia);
application.use(router);
application.mount("#app");
